// services/userapiservice.js
import axios from "axios";
import { attachAuthRefreshInterceptor } from "./authRefreshInterceptor";

const API_URL = `${process.env.REACT_APP_API_URL}`;

const api = axios.create({
  baseURL:API_URL, // e.g. http://localhost:4000
  withCredentials: true,
});
attachAuthRefreshInterceptor(api);

// Normalize API responses that may be {statusCode, body:{message, data}} or {data}
api.interceptors.response.use(
  (response) => {
    const d = response.data;
    // If shape is { statusCode, body: { message, data } }
    if (d && d.body && typeof d.body === "object") {
      response.data = {
        ...(d.body.data || {}),
        __meta: { message: d.body.message, statusCode: d.statusCode },
      };
    }
    // If shape is { message, data }
    else if (d && d.data && typeof d.data === "object" && !d.body) {
      response.data = { ...(d.data || {}), __meta: { message: d.message } };
    }
    // else leave as-is (already a plain object)
    return response;
  },
  (error) => Promise.reject(error)
);

// ------- Profile APIs -------
export const getMyProfile = (params = {}) => api.get("/account/me", { params });
export const getPracticePartners = () => api.get("/account/practice-partners");
export const getPracticeNames = (params = {}) => api.get("/account/practice-names", { params });

export const updateProfile = (payload) =>
  api.put("/account", payload);

export const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append("avatar", file);
  return api.post("/account/avatar", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const enableMfa = (enabled = true) =>
  api.post("/account/mfa", { enabled });

export const setupTotp = () =>
  api.get("/account/totp/setup");

export const verifyTotp = (code) =>
  api.post("/account/totp/verify", { code });

export const disableTotp = () =>
  api.post("/account/totp/disable");

export const regenerateRecoveryCodes = (code) =>
  api.post("/account/totp/recovery-codes/regenerate", { code });

export const getReferral = () =>
  api.get("/account/referral");

// Change password (Settings)
export const changePassword = (oldPassword, newPassword) =>
  api.post("/auth/password/change", { oldPassword, newPassword });

export const scrapeDoctors = (payload) => api.post("/profile/scrape-doctors", payload);

export const getScrapeProgress = (jobId) => api.get(`/profile/scrape-progress/${jobId}`);

export default api;
